export const getUserRole = () => {
  return localStorage.getItem('user_role')
}